import { TreatmentType } from "@redotech/redo-ab-testing-common/split";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const shopperAgentSplitSummarySchema = z.object({
  splitId: zExt.objectId(),
  splitName: z.string(),
  team: z.object({ id: zExt.objectId(), name: z.string() }),
  active: z.boolean(),
  startDate: z.date(),
  endDate: z.date().nullable(),
  attributionWindowDays: z.number().int().positive(),
  treatmentBuckets: z.array(z.number().int().min(0).max(999)),
  treatmentType: z.literal(TreatmentType.SHOPPER_AGENT),
});
export type ShopperAgentSplitSummary = z.infer<
  typeof shopperAgentSplitSummarySchema
>;

export const getShopperAgentSplits = {
  name: "getShopperAgentSplits" as const,
  input: z.object({
    /**
     * If supplied, return splits only for this team. Otherwise return
     * every ShopperAgent split across all teams (admin dashboard view).
     */
    teamId: zExt.objectId().optional(),
  }),
  output: z.array(shopperAgentSplitSummarySchema),
};
